var Acr = Acr || {};

Acr.CampaignManager = (function () {
  var campaignKeyNames;
  var Utility;

  function saveCampaignInCookie() {
    for (var i = 0; i < campaignKeyNames.length; i++) {
      if (Utility.getUrlParameterValue(campaignKeyNames[i])) {
        Utility.setCookie('campaignName', Utility.getUrlParameterValue(campaignKeyNames[i]), 0);
      }
    }
  }

  function init() {
    campaignKeyNames = ['cid', 'cmpid'];
    Utility = window.Utility || {};
    saveCampaignInCookie();
  }

  /**
  * Set the campaign name based on a URL attribute.
  * @param {String} text data to append the campaing name obtained from the URL.
  * @return {String} formatted data with the campaign name appended.
  */
  function appendCampaignName(text) {
    var result = text;
    var campaignNameValue = Utility.getCookie('campaignName');
    if (campaignNameValue) {
      result += '&campaignName=' + campaignNameValue;
    }
    return result;
  }


  return {
    init: init,
    appendCampaignName: appendCampaignName,
  };
}());
